// Il TICKET del socket del tavolo di burraco: la forma del corpo e della risposta del BFF di Limulo
// (`POST /v1/games/burraco/session-ticket`, endpoint `qlash.games.burraco.session-ticket.issue`, capability
// `burraco.session.ticket.issue`). Funzioni PURE, niente rete: la mutation sta in `services/limuloApi.ts` (`issueBurracoTicket`).
//
// Forma COPIATA dalla fonte, non inventata: QLASHGeminiZ/QBurraco @ 04b708ceeb11a6ebba8db638a903dbe0e98a0bee, `limulo-app/`
// (sha per file: catalogo 4249e2964603f36180a1983dcb940dc58b2f9878, resolvers e2d7fbe41c3cd9567a6be86756c57440e58456ac,
// manifest 11e8acb90587e6567f2f7093031e9e22504613fa):
//   · bff-endpoint-catalog.proposal.js — la voce `qlash.games.burraco.session-ticket.issue` (POST, `/v1/games/burraco/session-ticket`)
//   · backend/resolvers.js — `buildTicketPurpose` (`purpose: "table:<tableId>"`, UNO solo: `spectate` non esiste, ADR-0124 §4) e
//     `ticketIssue` (risposta `{ ticket, expiresInSeconds, wsUrl, purpose }`; senza `ticket` o `wsUrl` e un 502)
// La stessa copia sta andando in Qlash-IT/qlash-limulo come PR di mirror (cantiere 19, kb#383): finche non e' su Limulo staging
// la rotta risponde 404/424 e la pagina lo dice («non ancora disponibile»).
//
// Il ticket e MONOUSO e dura 30 s: chi lo chiede lo chiede a OGNI connessione (lib/burraco/socket.ts), mai da una cache, mai salvato.

/** La rotta del BFF. Una POST: non si ritenta mai da sola (un nuovo tentativo e un ticket NUOVO, ADR-0124 §4). */
export const BURRACO_TICKET_ROUTE = '/v1/games/burraco/session-ticket';

/** L'`id` della rotta `burraco/tavolo/:id` e l'uuid del tavolo del game host: altro non apre nessun socket. */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const burracoTableIdValido = (id: string | null | undefined): id is string => typeof id === 'string' && UUID.test(id);

/** Lo scopo del ticket di chi GIOCA. ⛔ Solo `table:`: gli spettatori non esistono (informazione nascosta, ADR-0124 §4). */
export const burracoTicketPurpose = (tableId: string): string => `table:${tableId}`;

export const burracoTicketBody = (tableId: string): { purpose: string } => ({ purpose: burracoTicketPurpose(tableId) });

export interface BurracoTicketGrant {
  ticket: string;
  wsUrl: string;
}

const asRecord = (v: unknown): Record<string, unknown> => (v !== null && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : {});
const testo = (v: unknown): string | null => (typeof v === 'string' && v.trim() !== '' ? v.trim() : null);

/**
 * Il ticket dal `data` del BFF. Un ticket senza indirizzo, o un indirizzo senza ticket, e `null`: `wsUrl: ""` e proprio il caso
 * di `PUBLIC_WS_URL` mancante sul game host, e un indirizzo vuoto non e un indirizzo. L'indirizzo e QUELLO della risposta:
 * nessun host scritto qui e nessuna `VITE_*` per il game host.
 */
export function burracoTicketGrantOf(data: unknown): BurracoTicketGrant | null {
  const r = asRecord(data);
  const ticket = testo(r.ticket);
  const wsUrl = testo(r.wsUrl);
  return ticket !== null && wsUrl !== null ? { ticket, wsUrl } : null;
}
